/**
 * The clickwrap wording, shown on the signup screen and sent back with the acceptance so the server
 * stores what was actually displayed.
 *
 * Mirrors DEFAULT_TERMS_LABEL in the API's constants/legal.ts. It is duplicated rather than shared
 * because the two apps have no common package, and it MUST stay identical: the server falls back to
 * its own copy when a client omits the label, and a divergence would record a sentence nobody saw.
 */
export const termsLabelFor = (version: string) =>
  `I have read and agree to the Gifts for Good Platform Terms & Conditions (${version})`;

/**
 * Shown when no version has been published, so there is nothing to agree to.
 *
 * A dead end by design: signup cannot continue, because an account created without a recorded
 * acceptance is an account GFG cannot later show agreed to anything. It names an address rather
 * than a retry, since the fix is an upload by GFG and not anything the client can do.
 */
export const NO_TERMS_DIALOG = {
  title: "Terms of Service unavailable",
  body: "No Terms of Service has been uploaded. Please contact it@giftsforgood.com to proceed. Your patience is appreciated.",
  dismiss: "Close",
} as const;
